"use client";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Monitor, Moon, Sun } from "lucide-react";
import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function ThemeToggle() {
  const t = useTranslations();
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="size-10 rounded-full bg-card/20 text-white hover:bg-card/30 hover:text-white"
        >
          <Sun
            className={`size-[18px] transition-transform duration-200 ${mounted && theme !== "system" && theme !== "dark" ? "scale-100" : "scale-0"}`}
          />
          <Moon
            className={`absolute size-[18px] transition-transform duration-200 ${mounted && theme === "dark" ? "scale-100" : "scale-0"}`}
          />
          <Monitor
            className={`absolute size-[18px] transition-transform duration-200 ${!mounted || theme === "system" ? "scale-100" : "scale-0"}`}
          />
          <span className="sr-only">{t("component-title.theme.toggle")}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => setTheme("light")}
          className={theme === "light" ? "bg-accent" : ""}
        >
          <Sun className="mr-2 size-4" />
          {t("component-title.theme.light")}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme("dark")}
          className={theme === "dark" ? "bg-accent" : ""}
        >
          <Moon className="mr-2 size-4" />
          {t("component-title.theme.dark")}
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => setTheme("system")}
          className={theme === "system" ? "bg-accent" : ""}
        >
          <Monitor className="mr-2 size-4" />
          {t("component-title.theme.system")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
